import React from 'react';
import IconButton from '../../../icon-button';
const ArrowButton = (props) => {
  const {
    selectProps: { isDisabled },
    innerProps,
  } = props;

  return (
    <div {...innerProps} className="ws-ui-base-select__arrow-button">
      <IconButton
        disabled={isDisabled}
        glyph="down-small"
        onMouseDown={innerProps.onMouseDown}
        size="medium"
        transparent
      />
    </div>
  );
};

export default ArrowButton;
